import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';
import Overlay from './overlay';

const DeleteButton = ({ id, name, fetchData }) => {
  const [inDeleteMode, setInDeleteMode] = useState(false);

  return (
    <>
      <Button
        icon={Delete}
        onPress={() => {
          setInDeleteMode(true);
        }}
        accessibilityLabel="Delete"
        variant={{ text: true }}
      />
      {inDeleteMode && (
        <Overlay
          setInDeleteMode={setInDeleteMode}
          id={id}
          name={name}
          fetchData={fetchData}
        />
      )}
    </>
  );
};

DeleteButton.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default DeleteButton;
